
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Fourtizeroseaterbusonrentinpune() {



  const cardData =
  {
    keyword: '  40 Seater Bus on Rent in Pune',
    heading: 'Vaishnavi Travels:  40 Seater Bus on Rent in Pune',
    headingDescription: 'Vaishnavi Travels offers dependable and affordable 40 Seater Bus on Rent in Pune, ideal for large group travel including weddings, school excursions, corporate outings, and outstation tours. Our buses are well-maintained with spacious interiors, comfortable seating, strong air-conditioning, and ample luggage capacity to ensure a pleasant journey for every passenger. With experienced drivers, punctual service, and flexible booking options, we make group travel easy and stress-free. Whether it’s a religious yatra, family function, business trip, or holiday tour, Vaishnavi Travels guarantees safe, reliable, and convenient 40 seater bus rental services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

  "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace and a proud symbol of Maratha heritage. Once the seat of power of the Maratha Empire, its mighty gates, sprawling gardens, and ruined bastions narrate tales of valor and glory. Though partially destroyed by a fire in 1828, the fort still stands as a majestic landmark. The evening light-and-sound show recreates the romance of Bajirao and Mastani and the grandeur of the Peshwas. Thousands of visitors explore its corridors, courtyards, and gardens every day. Shaniwar Wada remains Pune’s proud cultural and historic centerpiece."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, constructed in 1892, is a historic monument closely tied to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, it houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its majestic Italian arches, sprawling lawns, and colonial architecture make it a popular attraction. Tourists enjoy the calm and serene ambiance of its gardens while soaking in history. Aga Khan Palace stands as Pune’s inspirational monument of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 25 km from Pune, Sinhagad Fort is famous for the 1670 battle in which Tanaji Malusare fought heroically for Chhatrapati Shivaji Maharaj. Perched atop a hill, it offers panoramic views of the Sahyadris and trekking opportunities for adventure lovers. The fort is dotted with ancient bastions, temples, and memorials echoing Maratha bravery. In monsoon, mist and waterfalls add a magical touch to the trek. Local villagers serve traditional pithla-bhakri, making the trip even more authentic. Sinhagad is Pune’s perfect mix of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. Established more than 125 years ago, the temple is famous for its magnificent idol adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the epicenter of vibrant celebrations attracting lakhs of devotees. Beyond rituals, the temple is renowned for its charitable, cultural, and social initiatives. Tourists and devotees alike experience the spiritual energy and grandeur here. Dagdusheth Ganpati is Pune’s spiritual and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved in the 8th century, the Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. Featuring massive stone pillars, a sanctum, and a Nandi mandapa, it is a fine example of early Indian rock-cut architecture. Despite being located in the city center, the temple offers a peaceful and meditative environment. Evening prayers and chants fill the air with devotion and serenity. Tourists admire the craftsmanship and historical charm of this hidden heritage site. Pataleshwar Cave Temple is Pune’s spiritual retreat in the heart of the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure trove showcasing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits range from musical instruments, sculptures, and ornaments to everyday household objects of past centuries. The recreated Mastani Mahal is a highlight that fascinates history lovers. Students and tourists find the museum both educational and inspiring. It preserves India’s cultural traditions and artistry across eras. Raja Dinkar Kelkar Museum is Pune’s proud celebration of heritage, history, and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage sites, offers a panoramic view of the city from its hilltop temple complex. The Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller temples and museums nearby add cultural depth to the visit. Visitors climb 103 stone steps to reach the top, combining devotion with a healthy trek. Sunrise and sunset views from here are truly mesmerizing. Parvati Hill is Pune’s sacred and scenic escape above the city."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort, located in Koregaon Park, is Pune’s global destination for spirituality, wellness, and mindfulness. Spread across beautifully landscaped gardens, it attracts seekers and tourists from across the world. The ashram offers meditation techniques, yoga practices, and personal growth workshops. Japanese Zen gardens and tranquil meditation halls create a serene atmosphere. Beyond spirituality, it promotes rejuvenation and holistic living. Osho Ashram is Pune’s international hub of peace, healing, and inner growth."
  },
  {
    "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
    "description": "Inspired by the famous Korakuen Garden in Japan, Pu La Deshpande Garden is Pune’s largest landscaped park. It is designed with flowing streams, stone bridges, manicured lawns, and seasonal flowers. Families enjoy picnics, peaceful walks, and photography in this lush setting. The garden is also a symbol of Indo-Japanese cultural friendship. Nature lovers find it refreshing throughout the year, especially in spring. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built across the Mutha River, is a popular weekend spot just outside Pune. It not only supplies water to the city but also offers stunning views of hills, backwaters, and sunsets. In monsoon, the overflowing dam creates breathtaking sights. Locals and tourists enjoy roadside snacks like roasted corn and tea along the banks. It is also the starting point for trips to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural getaway for families and travelers alike."
  }
],

"services": [
{
"name": "40 Seater Bus Hire Pune",
"description": "Reliable 40 seater bus hire services in Pune, perfect for large groups seeking comfortable and spacious travel options. Our fleet includes well-maintained buses with both AC and non-AC variants, suitable for corporate outings, family trips, school tours, and event transportation. Professional drivers ensure safe and timely journeys, with flexible booking options tailored to your travel needs, including hourly, full-day, and multi-day rentals."
},
{
"name": "Large Group Bus Rental Pune",
"description": "Specialized bus rental services for large groups in Pune, offering spacious 40 seater buses equipped with comfortable seating, ample legroom, and generous luggage compartments. Ideal for weddings, religious functions, corporate events, and sightseeing tours, these buses deliver a balance of comfort and convenience with experienced chauffeurs ensuring smooth travel experiences for your group."
},
{
"name": "AC Bus 40 Seater Pune",
"description": "Premium air-conditioned 40 seater bus rentals in Pune designed to provide cool and comfortable journeys regardless of the weather. These buses come with modern amenities such as reclining seats, entertainment systems, and climate control, making them perfect for long-distance travel, corporate events, wedding functions, and outstation trips. Our trained drivers are familiar with Pune routes and nearby highways, ensuring safe and punctual arrivals."
},
{
"name": "Wedding 40 Seater Bus Booking",
"description": "Elegant 40 seater bus hire services tailored specifically for weddings in Pune. Our buses include AC and non-AC options, decorated as per your requirements, and managed by courteous drivers who understand the importance of timely and safe transportation during wedding events. Perfect for transporting large groups of guests comfortably between hotels, venues, and reception locations."
},
{
"name": "School Tour 40 Seater Bus Pune",
"description": "Safe and reliable 40 seater buses ideal for school tours and educational trips in Pune. Our buses are equipped with child safety features, including seat belts and clean interiors, with drivers trained to handle student transportation responsibly. Whether for day trips, excursions, or multi-day tours, we ensure punctuality, comfort, and peace of mind for school authorities and parents."
},
{
"name": "Corporate Event 40 Seater Bus",
"description": "Efficient and professional 40 seater bus rentals for corporate events in Pune, including meetings, conferences, and team outings. These buses offer comfortable seating, air conditioning, and flexible scheduling to meet business requirements. Our experienced drivers and customer support teams work together to provide seamless corporate travel experiences, ensuring your staff or guests arrive relaxed and on time."
},
{
"name": "Outstation 40 Seater Bus Hire Pune",
"description": "Dependable 40 seater bus rentals for outstation travel originating from Pune, catering to groups heading to nearby cities, tourist destinations, or long-distance journeys. These buses come with all-inclusive packages that cover tolls, fuel, and driver allowances, along with comfortable interiors and optional air conditioning. Our drivers are well-versed in highway navigation and traffic rules, providing safe and hassle-free travel."
},
{
"name": "Budget 40 Seater Bus Rental",
"description": "Affordable 40 seater bus rental options in Pune designed to meet budget constraints without sacrificing quality or safety. Perfect for schools, social events, group tours, and corporate outings, these buses offer ample seating and reliable performance. Transparent pricing with no hidden charges ensures you get the best value, supported by courteous drivers and flexible rental durations."
},
{
"name": "Non AC 40 Seater Bus Pune",
"description": "Cost-effective non-AC 40 seater bus rentals in Pune, ideal for short-distance travel, local tours, and budget-friendly group transportation. These buses provide sufficient comfort and safety features, driven by trained chauffeurs focused on punctuality and smooth rides. Suitable for school outings, family events, and local group travel where air conditioning is not a priority."
},
{
"name": "40 Seater Tourist Bus Hire",
"description": "Spacious 40 seater tourist bus rentals in Pune crafted for sightseeing and leisure travel. Equipped with comfortable seats, large windows for scenic views, and optional AC, these buses are perfect for exploring nearby hill stations, heritage sites, and popular tourist attractions. Our experienced drivers and customizable itineraries help create memorable and enjoyable tour experiences."
},
{
"name": "Long Distance Bus 40 Seater Pune",
"description": "Reliable long-distance 40 seater bus rentals from Pune, suitable for interstate travel, corporate retreats, and extended family trips. Our buses offer spacious seating, luggage storage, and optional air conditioning to ensure comfortable journeys over long durations. Professional drivers follow safe driving practices and adhere to schedules, making your trip stress-free and pleasant."
},
{
"name": "Office Trip Bus Hire Pune",
"description": "Efficient and comfortable 40 seater bus rentals for office trips and corporate outings in Pune. Whether it’s a team-building event, conference, or day excursion, our buses provide ample space and amenities to keep your staff relaxed and productive. Flexible booking options and timely pickups ensure smooth coordination with your corporate calendar."
},
{
"name": "40 Seater Bus with Driver",
"description": "Convenient 40 seater bus rental services in Pune that include experienced and professional drivers for safe and stress-free travel. Our drivers are trained in customer service and local navigation, ensuring timely arrivals and courteous assistance. Whether for corporate events, weddings, or group tours, this package provides a complete solution with well-maintained buses and expert driving."
}
],
"tableData": [
["40 Seater Bus Hire Pune", "Large Group Bus Rental Pune"],
["AC Bus 40 Seater Pune", "Wedding 40 Seater Bus Booking"],
["School Tour 40 Seater Bus Pune", "Corporate Event 40 Seater Bus"],
["Outstation 40 Seater Bus Hire Pune", "Budget 40 Seater Bus Rental"],
["Non AC 40 Seater Bus Pune", "40 Seater Tourist Bus Hire"],
["Long Distance Bus 40 Seater Pune", "Office Trip Bus Hire Pune"],
["40 Seater Bus with Driver"]
],




"whychoose": [
  {
    "WhyChooseheading": "Affordable 40 Seater Bus on Rent in Pune",
    "WhyChoosedescription": "Vaishnavi Travels provides reliable and cost-effective 40 seater bus rentals in Pune, ideal for large group travel and events."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating for Large Groups",
    "WhyChoosedescription": "Our 40 seater buses offer ample legroom and comfortable seating to ensure a pleasant journey for every passenger."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each bus is regularly serviced and thoroughly cleaned to maintain high standards of safety and hygiene."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages Tailored to Your Needs",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options customized to fit your travel schedule and group size."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our skilled drivers ensure safe, timely, and courteous service, with deep knowledge of Pune routes and traffic."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "All-inclusive pricing covers fuel, tolls, taxes, and driver allowances for a hassle-free rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Events, Weddings, and Group Travel",
    "WhyChoosedescription": "Perfect for corporate functions, weddings, sightseeing tours, and large group outings within Pune and beyond."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Booking",
    "WhyChoosedescription": "Vaishnavi Travels offers round-the-clock assistance to help with bookings, changes, and travel inquiries."
  }
]


































  }








const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer 40 seater buses for rent in Pune?',
      answer: 'Yes, Vaishnavi Travels has well‑maintained 40 seater buses available for rent in Pune. These buses are ideal for large group travel such as corporate outings, family weddings, school trips, and outstation tours, offering both comfort and ample space for passengers and luggage.',
    },
    {
      question: 'Can I get both AC and Non‑AC variants of a 40 seater bus?',
      answer: 'Yes, both AC and Non‑AC 40 seater buses are available. AC models provide a cooler, more premium ride especially for longer journeys, while Non‑AC options are more budget‑friendly and still offer essential comfort and safety features.',
    },
    {
      question: 'What are the typical charges for renting a 40 seater bus in Pune?',
      answer: 'For local use (around 8‑10 hours and ~100 km), a 40 seater AC bus may cost around **₹ 11,800**, and Non‑AC versions may be in the range of **₹ 9,000‑₹ 10,000**, depending on the route, time, and amenities. Additional costs like tolls, parking, extra kilometres or hours will apply.',
    },
    {
      question: 'What amenities are included with a 40 seater bus rental?',
      answer: 'Amenities often include comfy push‑back or reclining seats, music / audio‑video systems, overhead luggage storage, possibly mobile charging points, and good leg room. AC buses will of course have climate control, and all buses will have safety features and a professional driver.',
    },
    {
      question: 'Are there extra charges beyond the base rental fare?',
      answer: 'Yes. Things like tolls, parking, extra hours beyond the booked time, extra kilometres, state permits (if going outstation), and driver allowances especially for overnight stays are extra. Vaishnavi Travels provides transparent quotes that include these when relevant.',
    },
    {
      question: 'How early should I book a 40 seater bus for Pune usage?',
      answer: 'For local trips, booking at least **2‑3 days** in advance helps to ensure availability. For more popular times (weekends, holidays), outstation routes, or AC / luxury variants, booking **1 week or more** ahead is safer.',
    },
    {
      question: 'Can pickup and drop‑off from multiple locations be arranged with a 40 seater bus?',
      answer: 'Yes, multiple pickup and drop‑off points within Pune or en route for outstation travel can be arranged. We plan the route to optimize travel time, and any extra kilometres or time required for multiple stops are included in the final cost estimate.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Manish Deshpande",
    position: "Corporate Team Lead",
    feedback:
      "We hired a 40 seater AC bus from Vaishnavi Travels for our annual company meet. The vehicle was clean, seats were comfortable, and AC worked well even during peak heat. The driver arrived on time and handled pickup from multiple locations smoothly. The transparency in cost (no surprise charges) made the experience very satisfying.",
    rating: 5,
  },
  {
    name: "Ms. Nivedita Kulkarni",
    position: "Parent Volunteer, School Tour Committee",
    feedback:
      "For a large school excursion, we needed a non‑AC 40 seater bus. Vaishnavi Travels provided one that was spacious, with ample luggage space, good ventilation, and the journey was safe. The driver was courteous, and the children were comfortable throughout. The cost was reasonable and the service was reliable — great choice for large group travel.",
    rating: 5,
    style: "style-2",
  },
];
















































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "40 Seater Bus on Rent in Pune",
  "image": "https://vaishnavitravel.com/assets/images/40-seater-bus-pune.jpg",
  "description": "Rent a 40 seater bus in Pune with Vaishnavi Travels, perfect for large group travel including weddings, corporate events, school tours, and outstation trips. Available in AC and Non AC options with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.82",
    "ratingCount": "2100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5800",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/40-seater-bus-on-rent-in-pune"
  }
};




  return (
    <div>

<Helmet>
  <title>40 Seater Bus on Rent in Pune | AC & Non AC Large Group Bus Hire | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Rent a 40 seater bus in Pune with Vaishnavi Travels, perfect for large group travel including weddings, corporate events, school tours, and outstation trips. Available in AC and Non AC options with experienced drivers."
  />
  <meta
    name="keywords"
    content="40 Seater Bus Hire Pune, Large Group Bus Rental Pune, AC Bus 40 Seater Pune, Wedding 40 Seater Bus Booking, School Tour 40 Seater Bus Pune, Corporate Event 40 Seater Bus, Outstation 40 Seater Bus Hire Pune, Budget 40 Seater Bus Rental, Non AC 40 Seater Bus Pune, 40 Seater Tourist Bus Hire, Long Distance Bus 40 Seater Pune, Office Trip Bus Hire Pune, 40 Seater Bus with Driver"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/19.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fourtizeroseaterbusonrentinpune;